/**
 * Constantes para uso de tipos de búqueda.
 */
module.exports = {

    TODOS: 1,
    SUJETO_ACTIVO: 2,
    REPRESENTADO: 3,
    AUDIENCIA: 4,
    SUJETO_PASIVO: 5,
    VIAJE: 6,
    DONATIVO: 7,
    CASO: 8,
    ORDENCOMPRA: 9,
    LICITACION: 10,
	ORGANISMO: 11,
	PROVEEDOR: 12
}


// WEBPACK FOOTER //
// ./src/busqueda/config/tipo-busqueda.config.js